import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Card } from "@amzn/stencil-react-components/card";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { useIntl } from "react-intl";

export interface ChatbotBannerProps {
  onLaunch: () => void;
}

/**
 * Banner prompting the user to open the AI chatbot.
 *
 * The Aiva mark deliberately does not appear here — per the design it belongs on
 * Aiva's own conversation turns (see `AivaAvatar`), so that the avatar always
 * signals authorship rather than decorating unrelated surfaces.
 */
export function ChatbotBanner({ onLaunch }: ChatbotBannerProps): JSX.Element {
  const intl = useIntl();

  return (
    <Card
      padding="S300"
      backgroundColor="color.fill.muted.pink"
      borderRadius="dimensions.border.radius.200"
      dataTestId="chatbot-banner"
    >
      <Col gridGap="S200" flex={1}>
        <Text fontSize="T200" fontWeight="bold">
          {intl.formatMessage({ id: "chatbot-banner-title" })}
        </Text>
        <Text fontSize="T200" color="color.text.secondary">
          {intl.formatMessage({ id: "chatbot-banner-message" })}
        </Text>
        <Row>
          <Button
            variant={ButtonVariant.Secondary}
            onClick={onLaunch}
            dataTestId="chatbot-banner-launch-btn"
          >
            {intl.formatMessage({ id: "chatbot-header-title" })}
          </Button>
        </Row>
      </Col>
    </Card>
  );
}
